import axios from "axios";

const API_BASE = process.env?.REACT_APP_API_URL || undefined;

const PUBLIC_API = axios.create({
  baseURL: API_BASE ? API_BASE.replace(/\/$/, "") : undefined,
  headers: { "Content-Type": "application/json" },
});

export type PublicIntegrationStatus = {
  key: string;
  label: string;
  state: "operational" | "maintenance" | "instability";
  message: string | null;
  updatedAt: string;
};

export type PublicStatusIncident = {
  id: number;
  integrationKey: string;
  previousState: string | null;
  newState: string;
  message: string | null;
  createdAt: string;
};

export type PublicAnnouncement = {
  id: number;
  title: string;
  body: string;
  category: string;
  publishedAt: string | null;
};

export type PublicStatusResponse = {
  overall: "operational" | "maintenance" | "instability";
  integrations: PublicIntegrationStatus[];
  incidents: PublicStatusIncident[];
  announcements: PublicAnnouncement[];
};

export const getPublicStatus = async () => {
  const { data } = await PUBLIC_API.get<{ ok: true; data: PublicStatusResponse }>("/api/status");
  return data.data;
};
